import { AlertCircle, X } from 'lucide-react';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';
import { useDismissedUIElements } from '@/hooks/useDismissedUIElements';

interface CopiedJobNoticeProps {
  jobId: string;
}

export function CopiedJobNotice({ jobId }: CopiedJobNoticeProps) {
  const { isDismissed, dismiss } = useDismissedUIElements('copied_job_notice', { job_id: jobId });

  if (isDismissed) return null;

  return (
    <Alert className="border-amber-500/50 bg-amber-50 dark:bg-amber-950/20">
      <AlertCircle className="h-5 w-5 text-amber-600 dark:text-amber-500" />
      <AlertDescription className="flex items-start justify-between gap-4">
        <p className="text-sm text-amber-800 dark:text-amber-200">
          This is a copied job. Please click the Edit Job button below and review all copied details - including dates - to ensure they're correct for your current needs.
        </p>
        <Button
          variant="ghost"
          size="icon"
          className="h-6 w-6 shrink-0 text-amber-600 hover:text-amber-900 dark:text-amber-500 dark:hover:text-amber-100"
          onClick={() => dismiss()}
        >
          <X className="h-4 w-4" />
        </Button>
      </AlertDescription>
    </Alert>
  );
}
